import { useEffect } from 'react';

import {
  buildPreparedNQMMOrderState,
  type PreparedNQMMOrder,
  type PreparedNQMMOrderState,
} from '../components/ManualOrderEntry/preparedOrder';

interface UseManualOrderPreparedOrderOptions {
  onCancelEditing?: () => void;
  onPreparedOrder: (order: PreparedNQMMOrderState) => void;
}

/** Handle internal NQMM handoff events that prefill the manual-order form. */
export const useManualOrderPreparedOrder = ({
  onCancelEditing,
  onPreparedOrder,
}: UseManualOrderPreparedOrderOptions) => {
  useEffect(() => {
    const handlePreparedNQMMOrder = (event: Event) => {
      const detail = (event as CustomEvent<PreparedNQMMOrder>).detail;
      if (detail?.openInModal) return;
      const order = buildPreparedNQMMOrderState(detail);
      if (!order) return;

      onCancelEditing?.();
      onPreparedOrder(order);
      window.setTimeout(() => {
        document.getElementById('manual-order-entry')?.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      }, 0);
    };

    window.addEventListener('nqmm-prepare-order', handlePreparedNQMMOrder);
    return () => window.removeEventListener('nqmm-prepare-order', handlePreparedNQMMOrder);
  }, [onCancelEditing, onPreparedOrder]);
};
